import ProductInfoGallery from "gatsby-theme-dettol/src/components/ProductInfoGallery/ProductInfoGallery"

import "./ProductInfoGalleryOverride.scss"

export default ProductInfoGallery